export const CHANGE_WORKSPACE = 'CHANGE_WORKSPACE';
export const CLEAR_WORKSPACE = 'CLEAR_WORKSPACE';
